export function getFilters() {
  if (localStorage.getItem("__filters")) {
    return JSON.parse(localStorage.getItem("__filters"));
  }
  return {};
}

export function getFilter(key) {
  const filters = getFilters();
  return filters[key];
}

export function setFilter(key, value) {
  const filters = getFilters();
  filters[key] = value;
  localStorage.setItem("__filters", JSON.stringify(filters));
}



// WEBPACK FOOTER //
// ./src/helpers/globalFilters.js